import type { WarrantCardData } from './types';

export const SAMPLE_CARD: WarrantCardData = {
  code: '115510',
  issuer: 'CGS',
  type: 'call',
  underlying_ticker: 'MAYBANK',
  expiry_date: '2027-06-30',
  strike: 10.5,
  display_strike: 'RM 10.50',
  ratio_raw: 4.0,
  display_ratio: '4.00x',
  underlying_price: 10.2,
  display_underlying_price: 'RM 10.20',
  bid: 0.15,
  display_bid: 'RM 0.150',
  ask: 0.155,
  display_ask: 'RM 0.155',
  metrics: {
    days_to_expiry: 256,
    display_days_to_expiry: '256 days',
    mid: 0.1525,
    display_mid: 'RM 0.153',
    spread_pct: 0.0328,
    display_spread_pct: '3.3%',
    headline_iv: 0.425,
    display_headline_iv: '42.5%',
    headline_iv_basis: 'mid',
    effective_gearing: 5.2,
    display_effective_gearing: '5.20x',
    delta_share: 0.52,
    display_delta_share: '0.520',
    gamma: 0.12,
    display_gamma: '0.120',
    vega_per_point: 0.0015,
    display_vega_per_point: 'RM 0.0015',
    theta_per_day: -0.002,
    display_theta_per_day: '-RM 0.0020',
    premium: 0.085,
    display_premium: '8.5%',
    breakeven_price: 11.12,
    display_breakeven_price: 'RM 11.12',
    required_move: 0.09,
    display_required_move: '+9.0%',
    cross_check: {
      iv_diff_points: 1.5,
      eg_diff_rel: 0.02,
    },
  },
  holding_days: 5,
  presets: {
    spread_cost: 0.033,
    display_spread_cost: '3.3%',
    flat_decay: 0.02,
    display_flat_decay: '2.0%',
    iv_crush: 0.04,
    display_iv_crush: '4.0%',
    breakeven_move: 0.03,
    display_breakeven_move: '+3.0%',
  },
  flags: [
    {
      code: 'WIDE_SPREAD',
      severity: 'warn',
      threshold: '>3.0%',
      value: '3.3%',
      text: 'Bid-ask spread exceeds 3.0%',
    },
  ],
  not_evaluated: [],
  as_of: '2026-10-16 16:30',
  mode: 'replay',
};
